import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CommunicationService {
  public floatingChatToggle: Subject<any> = new Subject<any>();
  public downloadSubject: Subject<any> = new Subject();
  constructor() { }
}
